import React, { useRef } from 'react';
import { Form, Label, Input, Alert} from 'reactstrap';
import Buttons from '../Buttons';

const AgentInfo = ({ handleForm, showAlert, fromContact, listingAgent, onClose }) => {
  const agentEmailRef = useRef()
  const agentCellphoneRef = useRef()

  const handleSubmit = () => {
    handleForm({
      agentEmail: agentEmailRef.current.value,
      agenteCell: agentCellphoneRef?.current?.value,
    },
    "findAgent"
    )
  }

  const onUseListingAgent = () => {
    handleForm(listingAgent, "useListingAgent");
  };


  return (
    <>
      { showAlert?.show && <Alert color="danger" className="agent-info-alert"> {showAlert?.txt} </Alert>}
      <Form className="dyna-form login-form">
        <Label for="agentEmail" className="login-form-label required">Agent Email:</Label>
        <Input innerRef={agentEmailRef} className="mg-btm-10" type="email" name="agentEmail" id="agentEmail" placeholder="Enter agent email" />
        {/* <Label for="agentCellphone" className="login-form-label">Agent Cell Phone:</Label>
        <InputMask
          alwaysShowMask={true}
          aria-label="phone-input"
          mask='(999) 999-9999'
          className="mg-btm-10 form-control"
          type="tel"
          name="agentCellphone"
          id="agentCellphone"
          placeholder="Enter agent celphone"
          render={(agentCellphoneRef, props) => (
            <input innerRef={agentCellphoneRef} {...props} />
          )}
        /> */}

      </Form>
      <Buttons onClose={onClose} fromContact={fromContact} type={"AgentInfo"} onSubmit={handleSubmit} onUseListingAgent={onUseListingAgent}/>
    </>
  )
}

export default AgentInfo